/** HTTP header names used in the parquet server handler */
export const HeaderName = {
  Accept: "accept",
  AcceptRanges: "accept-ranges",
  Allow: "allow",
  Authorization: "authorization",
  CacheControl: "cache-control",
  Connection: "connection",
  ContentLength: "content-length",
  ContentRange: "content-range",
  ContentType: "content-type",
  Date: "date",
  ETag: "etag",
  IfMatch: "if-match",
  IfModifiedSince: "if-modified-since",
  IfNoneMatch: "if-none-match",
  IfUnmodifiedSince: "if-unmodified-since",
  LastModified: "last-modified",
  Range: "range",
  WWWAuthenticate: "www-authenticate",
} as const;

/** HTTP header values used in the parquet server handler */
export const HeaderValue = {
  AcceptRanges: "bytes",
  Allow: "GET, HEAD",
  CacheControl: "public, immutable, max-age=31536000",
  Connection: "close",
  ContentType: "application/octet-stream",
  WWWAuthenticate: 'Bearer realm="parquet-server"',
} as const;
